
<span class="euroAmount">
  <span class="accessibleAmount">{{ formatPrice(amount) }}</span>
  <span class="currency" aria-hidden="true">€</span>
  <span class="whole" aria-hidden="true">{{ parts[0] }}</span>
  <span class="cents" aria-hidden="true">{{ parts[1] }}</span>
</span>
